/*
  OTCD blog homepage: series scroller arrows and subscribe-form validation.

  No dependencies. Loaded with defer by every otcd-blog-* section, so it
  guards against running twice.

  Forms: both signup forms are Shopify `customer` forms, and after either one
  submits, Liquid renders the result on both. Shopify returns to
  /contact#<form id>, so the result is kept only on the form the fragment
  names. Browser validation stays the no-JS fallback; novalidate is set here.
*/
(function () {
  'use strict';

  if (window.otcdBlogHome) return;
  window.otcdBlogHome = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScroller(root) {
    var list = root.querySelector('[data-otcd-scroller-list]');
    var prev = root.querySelector('[data-otcd-scroll="prev"]');
    var next = root.querySelector('[data-otcd-scroll="next"]');
    if (!list || !prev || !next) return;

    function step() {
      var card = list.querySelector('li');
      var gap = parseFloat(getComputedStyle(list).columnGap) || 20;
      return card ? card.getBoundingClientRect().width + gap : list.clientWidth;
    }

    function update() {
      var max = list.scrollWidth - list.clientWidth - 2;
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= max;
    }

    function go(direction) {
      list.scrollBy({ left: direction * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initForm(form) {
    var input = form.querySelector('input[type="email"]');
    var message = form.querySelector('.otcd-form-msg');
    if (!input || !message) return;

    var result = form.querySelector('[data-otcd-form-result]');
    if (result && window.location.hash !== '#' + form.id) {
      result.textContent = '';
      result.className = 'otcd-form-msg';
      result.removeAttribute('data-otcd-form-result');
      result.removeAttribute('role');
      result.setAttribute('role', 'status');
      result.setAttribute('aria-live', 'polite');
      input.removeAttribute('aria-invalid');
    }

    form.setAttribute('novalidate', 'novalidate');

    form.addEventListener('submit', function (event) {
      var value = input.value.trim();
      if (value === '') {
        block(event, form.getAttribute('data-error-empty'));
        return;
      }
      if (!input.checkValidity() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        block(event, form.getAttribute('data-error-invalid'));
        return;
      }
      clear();
    });

    input.addEventListener('input', clear);

    function block(event, text) {
      event.preventDefault();
      message.textContent = text || '';
      message.className = 'otcd-form-msg is-error';
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    }

    function clear() {
      if (message.hasAttribute('data-otcd-form-result')) return;
      message.textContent = '';
      message.className = 'otcd-form-msg';
      input.removeAttribute('aria-invalid');
    }
  }

  function init() {
    var scrollers = document.querySelectorAll('[data-otcd-scroller]');
    for (var i = 0; i < scrollers.length; i++) initScroller(scrollers[i]);

    var forms = document.querySelectorAll('[data-otcd-subscribe]');
    for (var j = 0; j < forms.length; j++) initForm(forms[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-bind sections that are added or re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    var scrollers = root.querySelectorAll('[data-otcd-scroller]');
    for (var i = 0; i < scrollers.length; i++) initScroller(scrollers[i]);
    var forms = root.querySelectorAll('[data-otcd-subscribe]');
    for (var j = 0; j < forms.length; j++) initForm(forms[j]);
  });
})();
